import { Component, Input } from "@angular/core";

import { AuthService } from "../../../../shared/module/auth/auth.service";

import { IPayGuest } from "../../../../shared/module/auth/IPayGuest";

import { PitchData } from "../../../../shared/model/pitch";
import { Slot } from "../../../../shared/model/slot";
import { VenueData } from "../../../../shared/model/venue";

import { foldDownUpAnimation } from "pf_styleguide";

@Component({
    selector: "pf-booking-details",
    templateUrl: "./booking-details.component.html",
    styleUrls: ["./booking-details.component.scss"],
    animations: [foldDownUpAnimation],
})
export class BookingDetailsComponent {
    @Input() slot: Slot;
    @Input() pitch: PitchData;
    @Input() venue: VenueData;
    @Input() paid = 0;
    @Input() hideMobileThumbnail = false;
    @Input() modal = false;
    @Input() guestDetails: IPayGuest;

    detailsShowing = false;

    constructor(public authService: AuthService) {}
}
